import { css, Theme } from "@emotion/react";

export const breakWords = css({
    wordBreak: "break-all",
});

export const textContainer = css({
    wordBreak: "break-word",
});

export const linkedText = (theme: Theme) =>
    css({
        cursor: "pointer",
        textDecoration: "underline",
        color: theme.candy.typography.link.color,
    });

export const textError = (theme: Theme) =>
    css({
        color: theme.candy.semanticColors.danger.color,
    });

export const textWarning = (theme: Theme) =>
    css({
        color: theme.candy.semanticColors.warning.color,
    });

export const emptyOptionalText = (theme: Theme) =>
    css({
        color: theme.candy.typography.secondary.color,
        lineHeight: "22px",
    });
